import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useContext } from 'react';
import { useLocalStorage } from '@lib/hooks';
import { Country, Currency, getUserTimeZone, isWidget } from '@lib/services';
import { CampaignSetup } from '../campaignSetup';
export var Tip;
(function (Tip) {
    Tip["FivePercent"] = "five-percent";
    Tip["TenPercent"] = "ten-percent";
    Tip["FifteenPercent"] = "fifteen-percent";
    Tip["TwentyPercent"] = "twenty-percent";
    Tip["Other"] = "other";
})(Tip || (Tip = {}));
export const tipValues = {
    [Tip.FivePercent]: 5,
    [Tip.TenPercent]: 10,
    [Tip.FifteenPercent]: 15,
    [Tip.TwentyPercent]: 20,
    [Tip.Other]: undefined
};
export const EverGivePercentage = [0, 25, 50, 100];
export var SplitType;
(function (SplitType) {
    SplitType["Equally"] = "equally";
    SplitType["MoreOdd"] = "more-odd";
    SplitType["More27"] = "more-27";
    SplitType["MoreArafah"] = "more-arafah";
    SplitType["NotSelected"] = "not-selected";
    SplitType["MoreLastTenOddNights"] = "more-10-odd-nights";
})(SplitType || (SplitType = {}));
export var NightTypeOpt;
(function (NightTypeOpt) {
    NightTypeOpt["AllAvailable"] = "allAvailable";
    NightTypeOpt["LastTenAvailable"] = "lastTenAvailable";
})(NightTypeOpt || (NightTypeOpt = {}));
export const mtnSplitTexts = {
    [SplitType.Equally]: 'Split equally',
    [SplitType.MoreOdd]: 'More on odd nights',
    [SplitType.More27]: 'More on 27th',
    [SplitType.MoreLastTenOddNights]: 'More on last 10 odd nights'
};
export const mtdSplitTexts = {
    [SplitType.Equally]: 'Split Equally',
    [SplitType.MoreArafah]: 'More on Arafah'
};
export var Multiplier;
(function (Multiplier) {
    Multiplier[Multiplier["OnePointFive"] = 1.5] = "OnePointFive";
    Multiplier[Multiplier["Double"] = 2] = "Double";
    Multiplier[Multiplier["Triple"] = 3] = "Triple";
})(Multiplier || (Multiplier = {}));
export const defaultCharity = {
    about: '',
    registration_number: '',
    campaign: '',
    causes: [],
    selectedCauses: [],
    charity_id: '',
    charity_name: '',
    country: Country.GB,
    currency: Currency.GBP,
    gift_aid: false,
    privacy_policy_url: '',
    tax_receipt: false,
    partner: ''
};
export var CampaignDates;
(function (CampaignDates) {
    CampaignDates[CampaignDates["FirstNight"] = 20] = "FirstNight";
    CampaignDates[CampaignDates["StartDateOffset"] = 0] = "StartDateOffset";
})(CampaignDates || (CampaignDates = {}));
export const getDefaultPlan = () => {
    const tz = getUserTimeZone();
    return {
        campaign: CampaignSetup.currentCampaign,
        causes: {},
        selectedCauses: [],
        chainCode: '',
        chainCodeCharity: defaultCharity,
        charity: defaultCharity,
        detectedTimezone: tz,
        firstNight: 0,
        multiplier: Multiplier.Double,
        night30: true,
        split: SplitType.NotSelected,
        totalNight: { key: '', value: 0 },
        fridayGiving: 0,
        fridayGivingOptIn: '',
        wakf: 0,
        wakfOptIn: '',
        emailOptIn: true,
        charityEmailOptIn: false,
        timezone: tz !== '' ? tz : 'Europe/London',
        donorDetails: {
            addressLine1: '',
            country: '',
            email: '',
            firstName: '',
            lastName: '',
            houseNumber: '',
            postalCode: '',
            isAddressFromLookup: false
        },
        paymentDetails: {
            giftAid: false,
            taxReceipt: false,
            payFees: true,
            tipPercent: Tip.TenPercent,
            tipValue: 0,
            payTip: true
        },
        startDateOffset: CampaignDates.StartDateOffset,
        autoEnroll: 'true',
        evergiveSharePercentage: null,
        egContributionOptIn: false
    };
};
const checkoutPlanContext = createContext({
    plan: getDefaultPlan(),
    setPlan: (p) => console.log(p),
    resetPlan: () => { },
    setCharity: (c) => console.log(c)
});
export const useCheckoutPlan = () => {
    const result = useContext(checkoutPlanContext);
    if (result.plan.campaign !== CampaignSetup.currentCampaign) {
        result.resetPlan();
    }
    return result;
};
export const CheckoutPlanProvider = ({ children }) => {
    const [plan, setPlan] = useLocalStorage('checkout_plan', getDefaultPlan());
    const setCharity = (charity) => {
        const causes = plan.charity.charity_id === charity.charity_id ? plan.causes : {};
        setPlan(Object.assign(Object.assign({}, plan), { charity, causes, selectedCauses: [] }));
    };
    const resetPlan = useCallback(() => {
        if (isWidget) {
            setPlan(Object.assign(Object.assign({}, getDefaultPlan()), { charity: plan.charity }));
            return;
        }
        setPlan(getDefaultPlan());
    }, [setPlan, plan.charity]);
    const value = {
        plan,
        setPlan,
        resetPlan,
        setCharity
    };
    return _jsx(checkoutPlanContext.Provider, Object.assign({ value: value }, { children: children }));
};
//# sourceMappingURL=data:application/json;base64,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